var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cc"},[_c('img',{staticClass:"cc-brand",attrs:{"src":_vm.cardLogo}}),_c('div',{staticClass:"cc-number"},[_vm._v(_vm._s(_vm.encryptedCard.lastFourDigits))]),_c('div',{staticClass:"cc-date"},[_vm._v(_vm._s(_vm.encryptedCard.expirationMonth)+" / "+_vm._s(_vm.encryptedCard.expirationYear))])])
}
var staticRenderFns = []

export { render, staticRenderFns }